
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 17 17","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.09163 8.50016C3.09163 5.55464 5.47945 3.16683 8.42497 3.16683C11.3705 3.16683 13.7583 5.55464 13.7583 8.50016C13.7583 11.4457 11.3705 13.8335 8.42497 13.8335C5.47945 13.8335 3.09163 11.4457 3.09163 8.50016ZM8.42497 1.8335C4.74307 1.8335 1.7583 4.81826 1.7583 8.50016C1.7583 12.1821 4.74307 15.1668 8.42497 15.1668C12.1069 15.1668 15.0916 12.1821 15.0916 8.50016C15.0916 4.81826 12.1069 1.8335 8.42497 1.8335ZM8.42497 5.16683C8.79316 5.16683 9.09163 5.46531 9.09163 5.8335V8.50016C9.09163 8.86835 8.79316 9.16683 8.42497 9.16683C8.05678 9.16683 7.7583 8.86835 7.7583 8.50016V5.8335C7.7583 5.46531 8.05678 5.16683 8.42497 5.16683ZM9.09163 11.1668C9.09163 11.535 8.79316 11.8335 8.42497 11.8335C8.05678 11.8335 7.7583 11.535 7.7583 11.1668C7.7583 10.7986 8.05678 10.5002 8.42497 10.5002C8.79316 10.5002 9.09163 10.7986 9.09163 11.1668Z","fill":"currentColor"}})])
          )
        }
      }
    